
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cbZqw", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $awd1Q = parcelRequire("awd1Q");


var $io723 = parcelRequire("io723");


var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $33344fa1a02cce50$export$2d0a3b8284ce9941 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.READ_TIME_SEGMENT_KEY)
});









var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $3IZob = parcelRequire("3IZob");


var $b3j2Y = parcelRequire("b3j2Y");


var $9wGTI = parcelRequire("9wGTI");


var $jtuBN = parcelRequire("jtuBN");


var $h2uld = parcelRequire("h2uld");











var $lGgRw = parcelRequire("lGgRw");


var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $jmjWc = parcelRequire("jmjWc");





var $gMc0m = parcelRequire("gMc0m");





var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");

var $1cfRh = parcelRequire("1cfRh");


var $3gadb = parcelRequire("3gadb");





var $x4n5k = parcelRequire("x4n5k");


var $6f0Oj = parcelRequire("6f0Oj");




var $2VQ4B = parcelRequire("2VQ4B");


var $luv00 = parcelRequire("luv00");





const $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    abbreviatedReadTime: {
        id: "read-time.by-line.abbreviated-estimated-read-time",
        defaultMessage: "{readTime} min"
    },
    readTime: {
        id: "read-time.by-line.estimated-read-time",
        defaultMessage: "{readTime} min read"
    },
    iconLabel: {
        id: "read-time.by-line.icon-label",
        defaultMessage: "Read time"
    },
    tooltipDescription: {
        id: "read-time.tooltip-description",
        defaultMessage: "Estimated read time"
    },
    wordCount: {
        id: "read-time.word-count",
        defaultMessage: "{wordCount} {wordCount, plural, one {word} other {words}}"
    }
});
const $cdcc5f8fb5019e0d$var$abbreviatedReadTimeStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    width: 'max-content',
    height: '24px'
});
const $cdcc5f8fb5019e0d$var$readTimeWithBulletStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex'
});
const $cdcc5f8fb5019e0d$var$baseStyledReadTime = null;
const $cdcc5f8fb5019e0d$var$detailsPanelStyledReadTime = null;
const $cdcc5f8fb5019e0d$var$underlineHoverStyles = (0, $ecnYn.xcss)({
    font: 'font.body',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $cdcc5f8fb5019e0d$var$abbreviatedReadTimeBadgeStyles = null;
const $cdcc5f8fb5019e0d$var$readTimeBullet = null;
function $cdcc5f8fb5019e0d$export$3e49eaea01c72fb7(t0) {
    const $ = (0, $frIzR.c)(21);
    const { pageId: pageId, readTime: readTime, isAbbreviatedReadTime: isAbbreviatedReadTime, isInEditor: isInEditor, isDetailsPanel: isDetailsPanel, wordCount: wordCount, showWordCount: showWordCount } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const useAbbreviatedReadTime = isAbbreviatedReadTime ?? (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline");
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isInEditor) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "page",
                    action: "displayed",
                    actionSubject: "tooltip",
                    actionSubjectId: "estimatedReadTime",
                    attributes: {
                        isInEditor: !!isInEditor
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isInEditor;
        $[2] = t1;
    } else t1 = $[2];
    const fireTooltipEvent = t1;
    let t2;
    let t3;
    if ($[3] !== createAnalyticsEvent || $[4] !== isInEditor || $[5] !== pageId || $[6] !== readTime) {
        t2 = ()=>{
            if (readTime) createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: "confluence-frontend",
                    action: "displayed",
                    actionSubject: "readTime",
                    actionSubjectId: pageId,
                    attributes: {
                        readTime: readTime,
                        isInEditor: !!isInEditor
                    }
                }
            }).fire();
        };
        t3 = [
            pageId,
            readTime,
            createAnalyticsEvent,
            isInEditor
        ];
        $[3] = createAnalyticsEvent;
        $[4] = isInEditor;
        $[5] = pageId;
        $[6] = readTime;
        $[7] = t2;
        $[8] = t3;
    } else {
        t2 = $[7];
        t3 = $[8];
    }
    (0, $42omo.useEffect)(t2, t3);
    const readTimeMessage = useAbbreviatedReadTime ? $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.abbreviatedReadTime : $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.readTime;
    const t4 = "read-time";
    const t5 = "read-time-component";
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            display: "inline-flex"
        };
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== formatMessage || $[11] !== isDetailsPanel || $[12] !== showWordCount || $[13] !== wordCount) {
        t7 = showWordCount && wordCount != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                isDetailsPanel && $cdcc5f8fb5019e0d$var$underlineHoverStyles
            ]
        }, formatMessage($cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.wordCount, {
            wordCount: wordCount
        }));
        $[10] = formatMessage;
        $[11] = isDetailsPanel;
        $[12] = showWordCount;
        $[13] = wordCount;
        $[14] = t7;
    } else t7 = $[14];
    const t8 = !!readTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            !useAbbreviatedReadTime && "_tw171r31 _135cglyw _1p5wnqa1 _1kt91mp2 _cfu11o8l _is06azsu _p7f0u2gc",
            isDetailsPanel ? "_2hwxidpf _syazi7uo _1e0c1txw _4cvr1h6o _tw171r31 _135cglyw _1p5wnqa1 _1kt91mp2 _cfu11o8l _is06i7uo _p7f01b66 _syay1b66" : "_2hwx1b66 _19bv12x7 _syazazsu",
            useAbbreviatedReadTime && "_2hwxze3t _19bv1b66 _u5f31b66 _80omtlke _4t3i1tcg _8vu412b0 _irr31dpa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.tooltipDescription),
        onShow: fireTooltipEvent,
        hideTooltipOnClick: true,
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            useAbbreviatedReadTime ? $cdcc5f8fb5019e0d$var$abbreviatedReadTimeStyles : $cdcc5f8fb5019e0d$var$readTimeWithBulletStyles,
            isDetailsPanel && $cdcc5f8fb5019e0d$var$underlineHoverStyles
        ]
    }, useAbbreviatedReadTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($x4n5k))), {
        label: formatMessage($cdcc5f8fb5019e0d$export$a7357cdd1f0b0168.iconLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        ...readTimeMessage,
        values: {
            readTime: readTime
        }
    }))));
    let t9;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
            metric: (0, $33344fa1a02cce50$export$2d0a3b8284ce9941)
        });
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== ssrPlaceholderIdProp || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": t4,
            "data-testid": t5,
            ...ssrPlaceholderIdProp,
            style: t6
        }, t7, t8, t9);
        $[16] = ssrPlaceholderIdProp;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t10;
    } else t10 = $[20];
    return t10;
}



const $b2726d89c406a12d$var$ReadTimePopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wHxOo",
    name: "ReadTimePopup",
    loader: async ()=>(await (parcelRequire("6vKU8"))).ReadTimePopup
});
const $b2726d89c406a12d$var$triggerStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    color: 'color.text',
    padding: 'space.0',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.neutral.subtle'
});
const $b2726d89c406a12d$export$eb6727f1763071f3 = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { contentId: contentId, isAbbreviatedReadTime: isAbbreviatedReadTime, isDetailsPanel: isDetailsPanel, showWordCount: showWordCount, features: features, featuresSkipExpand: featuresSkipExpand, wordCount: wordCount, readTime: readTime, source: source } = t0;
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent || $[2] !== isPopupOpen || $[3] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "readTime",
                    actionSubjectId: "readTimePopup",
                    source: source,
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
            setIsPopupOpen(!isPopupOpen);
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = isPopupOpen;
        $[3] = source;
        $[4] = t1;
    } else t1 = $[4];
    const onPageReadTimeClick = t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsPopupOpen(false);
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== contentId || $[7] !== features || $[8] !== featuresSkipExpand || $[9] !== source) {
        t3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b2726d89c406a12d$var$ReadTimePopup, {
                ...props,
                features: features,
                featuresSkipExpand: featuresSkipExpand,
                source: source,
                contentId: contentId
            });
        $[6] = contentId;
        $[7] = features;
        $[8] = featuresSkipExpand;
        $[9] = source;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== contentId || $[12] !== isAbbreviatedReadTime || $[13] !== isDetailsPanel || $[14] !== onPageReadTimeClick || $[15] !== readTime || $[16] !== showWordCount || $[17] !== wordCount) {
        t4 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                ...triggerProps,
                onClick: onPageReadTimeClick,
                xcss: $b2726d89c406a12d$var$triggerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cdcc5f8fb5019e0d$export$3e49eaea01c72fb7), {
                readTime: readTime,
                wordCount: wordCount,
                pageId: contentId,
                isAbbreviatedReadTime: isAbbreviatedReadTime,
                isDetailsPanel: isDetailsPanel,
                showWordCount: showWordCount
            }));
        $[11] = contentId;
        $[12] = isAbbreviatedReadTime;
        $[13] = isDetailsPanel;
        $[14] = onPageReadTimeClick;
        $[15] = readTime;
        $[16] = showWordCount;
        $[17] = wordCount;
        $[18] = t4;
    } else t4 = $[18];
    let t5;
    if ($[19] !== isPopupOpen || $[20] !== t3 || $[21] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
            isOpen: isPopupOpen,
            onClose: t2,
            placement: "bottom-start",
            content: t3,
            trigger: t4
        });
        $[19] = isPopupOpen;
        $[20] = t3;
        $[21] = t4;
        $[22] = t5;
    } else t5 = $[22];
    return t5;
};



var $72md5 = parcelRequire("72md5");


var $h3vPv = parcelRequire("h3vPv");

const $80e642dbd56c6416$export$961bca700bc56c3 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(51);
    const { contentId: contentId, editorApi: editorApi, showWordCount: showWordCount, isDetailsPanel: isDetailsPanel, isAbbreviatedReadTime: t1 } = t0;
    const isAbbreviatedReadTime = t1 === undefined ? true : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange } = (0, $3IZob.useDocChangeContext)();
    const [features, setFeatures] = (0, $42omo.useState)(null);
    const [featuresSkipExpand, setFeaturesSkipExpand] = (0, $42omo.useState)(null);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") && {
            status: [
                "current",
                "draft"
            ]
        };
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== contentId) {
        t3 = {
            variables: {
                contentId: contentId,
                ...t2
            }
        };
        $[1] = contentId;
        $[2] = t3;
    } else t3 = $[2];
    const readTimeQueryOptions = t3;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $h2uld.ReadTimeQuery), readTimeQueryOptions);
    const t4 = data ?? undefined;
    let t5;
    if ($[3] !== t4) {
        t5 = (0, $72md5.getAdf)(t4);
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    const adf = t5;
    let t6;
    if ($[5] !== adf) {
        t6 = (0, $72md5.calculateEstimatedReadTime)(adf);
        $[5] = adf;
        $[6] = t6;
    } else t6 = $[6];
    const [readTime, setReadTime] = (0, $42omo.useState)(t6);
    let t7;
    if ($[7] !== adf) {
        t7 = (0, $72md5.getWordCount)(adf);
        $[7] = adf;
        $[8] = t7;
    } else t7 = $[8];
    const [wordCount, setWordCount] = (0, $42omo.useState)(t7);
    let t8;
    if ($[9] !== adf || $[10] !== contentId || $[11] !== createAnalyticsEvent || $[12] !== data?.content?.nodes?.[0]?.type || $[13] !== error || $[14] !== loading) {
        t8 = ()=>{
            if (!createAnalyticsEvent || !adf || loading || error || !contentId) return;
            const contentType = data?.content?.nodes?.[0]?.type ?? "";
            createAnalyticsEvent((0, $72md5.getContentFeatureExtractedEventObject)({
                contentType: contentType,
                contentId: contentId,
                adf: adf,
                isInEditor: true
            })).fire();
        };
        $[9] = adf;
        $[10] = contentId;
        $[11] = createAnalyticsEvent;
        $[12] = data?.content?.nodes?.[0]?.type;
        $[13] = error;
        $[14] = loading;
        $[15] = t8;
    } else t8 = $[15];
    const t9 = data?.content?.nodes;
    let t10;
    if ($[16] !== adf || $[17] !== contentId || $[18] !== createAnalyticsEvent || $[19] !== error || $[20] !== loading || $[21] !== t9) {
        t10 = [
            contentId,
            loading,
            adf,
            t9,
            error,
            createAnalyticsEvent
        ];
        $[16] = adf;
        $[17] = contentId;
        $[18] = createAnalyticsEvent;
        $[19] = error;
        $[20] = loading;
        $[21] = t9;
        $[22] = t10;
    } else t10 = $[22];
    (0, $42omo.useEffect)(t8, t10);
    let t11;
    let t12;
    if ($[23] !== adf || $[24] !== error || $[25] !== loading) {
        t11 = ()=>{
            if (adf && !loading && !error) {
                setWordCount((0, $72md5.getWordCount)(adf));
                setReadTime((0, $72md5.calculateEstimatedReadTime)(adf));
            }
        };
        t12 = [
            adf,
            loading,
            error
        ];
        $[23] = adf;
        $[24] = error;
        $[25] = loading;
        $[26] = t11;
        $[27] = t12;
    } else {
        t11 = $[26];
        t12 = $[27];
    }
    (0, $42omo.useEffect)(t11, t12);
    let t13;
    if ($[28] !== editorApi) {
        t13 = async ()=>{
            if (editorApi) editorApi.core?.actions.requestDocument((doc)=>{
                setWordCount((0, $72md5.getWordCount)(doc));
                setReadTime((0, $72md5.calculateEstimatedReadTime)(doc));
                if (doc) {
                    setFeatures((0, $h3vPv.extractContentFeatures)(doc));
                    setFeaturesSkipExpand((0, $h3vPv.extractContentFeaturesSkipExpand)(doc));
                }
            });
        };
        $[28] = editorApi;
        $[29] = t13;
    } else t13 = $[29];
    const setReadTimeFromEditorState = t13;
    let t14;
    let t15;
    if ($[30] !== setReadTimeFromEditorState) {
        t14 = ()=>{
            setReadTimeFromEditorState();
        };
        t15 = [
            setReadTimeFromEditorState
        ];
        $[30] = setReadTimeFromEditorState;
        $[31] = t14;
        $[32] = t15;
    } else {
        t14 = $[31];
        t15 = $[32];
    }
    (0, $42omo.useEffect)(t14, t15);
    let t16;
    if ($[33] !== setReadTimeFromEditorState) {
        t16 = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(setReadTimeFromEditorState, 5000);
        $[33] = setReadTimeFromEditorState;
        $[34] = t16;
    } else t16 = $[34];
    const debouncedCalculateReadTime = t16;
    let t17;
    let t18;
    if ($[35] !== debouncedCalculateReadTime || $[36] !== subscribeDocChange || $[37] !== unsubscribeDocChange) {
        t17 = ()=>{
            subscribeDocChange(debouncedCalculateReadTime);
            return ()=>unsubscribeDocChange(debouncedCalculateReadTime);
        };
        t18 = [
            debouncedCalculateReadTime,
            subscribeDocChange,
            unsubscribeDocChange
        ];
        $[35] = debouncedCalculateReadTime;
        $[36] = subscribeDocChange;
        $[37] = unsubscribeDocChange;
        $[38] = t17;
        $[39] = t18;
    } else {
        t17 = $[38];
        t18 = $[39];
    }
    (0, $42omo.useEffect)(t17, t18);
    if (error) {
        let t19;
        if ($[40] !== error) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            $[40] = error;
            $[41] = t19;
        } else t19 = $[41];
        return t19;
    }
    if (readTime || showWordCount && wordCount != null) {
        let t19;
        if ($[42] !== contentId || $[43] !== features || $[44] !== featuresSkipExpand || $[45] !== isAbbreviatedReadTime || $[46] !== isDetailsPanel || $[47] !== readTime || $[48] !== showWordCount || $[49] !== wordCount) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b2726d89c406a12d$export$eb6727f1763071f3), {
                contentId: contentId,
                isAbbreviatedReadTime: isAbbreviatedReadTime,
                isDetailsPanel: isDetailsPanel,
                showWordCount: showWordCount,
                features: features,
                featuresSkipExpand: featuresSkipExpand,
                wordCount: wordCount,
                readTime: readTime,
                source: "editorReadTime"
            });
            $[42] = contentId;
            $[43] = features;
            $[44] = featuresSkipExpand;
            $[45] = isAbbreviatedReadTime;
            $[46] = isDetailsPanel;
            $[47] = readTime;
            $[48] = showWordCount;
            $[49] = wordCount;
            $[50] = t19;
        } else t19 = $[50];
        return t19;
    }
});





















const $70e8bb0fe98c8861$export$8b2e5877d9d93c3c = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { contentId: contentId, isAbbreviatedReadTime: isAbbreviatedReadTime, isDetailsPanel: isDetailsPanel, showWordCount: showWordCount } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { adf: adf, loading: loading, error: error, contentType: contentType, readTime: readTime, wordCount: wordCount, features: features, featuresSkipExpand: featuresSkipExpand } = (0, $h2uld.useReadTime)(contentId);
    let t1;
    let t2;
    if ($[0] !== adf || $[1] !== contentId || $[2] !== contentType || $[3] !== createAnalyticsEvent || $[4] !== error || $[5] !== loading) {
        t1 = ()=>{
            if (!createAnalyticsEvent || !adf || loading || error || !contentId || !contentType) return;
            createAnalyticsEvent((0, $72md5.getContentFeatureExtractedEventObject)({
                contentType: contentType,
                contentId: contentId,
                adf: adf,
                isInEditor: false
            })).fire();
        };
        t2 = [
            contentId,
            loading,
            error,
            contentType,
            createAnalyticsEvent,
            adf
        ];
        $[0] = adf;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = createAnalyticsEvent;
        $[4] = error;
        $[5] = loading;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $42omo.useEffect)(t1, t2);
    if (error) {
        let t3;
        if ($[8] !== error) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            $[8] = error;
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    if (readTime || showWordCount && wordCount !== null) {
        const t3 = wordCount ?? 0;
        let t4;
        if ($[10] !== contentId || $[11] !== features || $[12] !== featuresSkipExpand || $[13] !== isAbbreviatedReadTime || $[14] !== isDetailsPanel || $[15] !== readTime || $[16] !== showWordCount || $[17] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b2726d89c406a12d$export$eb6727f1763071f3), {
                contentId: contentId,
                isAbbreviatedReadTime: isAbbreviatedReadTime,
                isDetailsPanel: isDetailsPanel,
                showWordCount: showWordCount,
                features: features,
                featuresSkipExpand: featuresSkipExpand,
                wordCount: t3,
                readTime: readTime,
                source: "originalReadTime"
            });
            $[10] = contentId;
            $[11] = features;
            $[12] = featuresSkipExpand;
            $[13] = isAbbreviatedReadTime;
            $[14] = isDetailsPanel;
            $[15] = readTime;
            $[16] = showWordCount;
            $[17] = t3;
            $[18] = t4;
        } else t4 = $[18];
        return t4;
    }
    return null;
};


const $8f3b07438f5b7ca3$export$77dedcd16f070a20 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { contentId: contentId, editorApi: editorApi, isInEditor: isInEditor, isAbbreviatedReadTime: isAbbreviatedReadTime, isDetailsPanel: isDetailsPanel, showWordCount: showWordCount } = t0;
    const { locale: locale } = (0, $awd1Q.getTranslation)();
    const shouldRenderReadTime = locale && locale.substring(0, 2).toLowerCase() === "en";
    if (!shouldRenderReadTime) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            metric: (0, $33344fa1a02cce50$export$2d0a3b8284ce9941)
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId || $[2] !== editorApi || $[3] !== isAbbreviatedReadTime || $[4] !== isDetailsPanel || $[5] !== isInEditor || $[6] !== showWordCount) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, isInEditor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $80e642dbd56c6416$export$961bca700bc56c3), {
            contentId: contentId,
            editorApi: editorApi,
            showWordCount: showWordCount,
            isDetailsPanel: isDetailsPanel,
            isAbbreviatedReadTime: isAbbreviatedReadTime
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $70e8bb0fe98c8861$export$8b2e5877d9d93c3c), {
            contentId: contentId,
            isAbbreviatedReadTime: isAbbreviatedReadTime,
            isDetailsPanel: isDetailsPanel,
            showWordCount: showWordCount
        }));
        $[1] = contentId;
        $[2] = editorApi;
        $[3] = isAbbreviatedReadTime;
        $[4] = isDetailsPanel;
        $[5] = isInEditor;
        $[6] = showWordCount;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
module.exports["ReadTime"] = $8f3b07438f5b7ca3$export$77dedcd16f070a20;

});

parcelRegister("3IZob", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $10e4e925e54c9160$var$DocChangeContext = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribeDocChange: ()=>{},
    unsubscribeDocChange: ()=>{}
});
const $10e4e925e54c9160$var$DocChangeContextProvider = ({ children: children })=>{
    const subscriptions = (0, $42omo.useRef)(new Set());
    const handleDocChange = (0, $42omo.useCallback)((editorView)=>{
        subscriptions.current.forEach((callback)=>{
            callback(editorView);
        });
    }, []);
    const subscribeDocChange = (0, $42omo.useCallback)((callback)=>{
        subscriptions.current.add(callback);
    }, []);
    const unsubscribeDocChange = (0, $42omo.useCallback)((callback)=>{
        subscriptions.current.delete(callback);
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange
        }), [
        subscribeDocChange,
        unsubscribeDocChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10e4e925e54c9160$var$DocChangeContext.Provider, {
        value: value
    }, children({
        handleDocChange: handleDocChange
    }));
};
const $10e4e925e54c9160$export$82deeccbd0ef6b25 = ()=>(0, $42omo.useContext)($10e4e925e54c9160$var$DocChangeContext);
function $10e4e925e54c9160$export$9747c97496f7b432(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10e4e925e54c9160$var$DocChangeContextProvider, null, ({ handleDocChange: handleDocChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                ...props,
                handleDocChange: handleDocChange
            }));
}
module.exports["useDocChangeContext"] = $10e4e925e54c9160$export$82deeccbd0ef6b25;
module.exports["withDocChangeContext"] = $10e4e925e54c9160$export$9747c97496f7b432;

});

parcelRegister("h2uld", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $j25oo = parcelRequire("j25oo");


var $jtuBN = parcelRequire("jtuBN");


var $72md5 = parcelRequire("72md5");


var $h3vPv = parcelRequire("h3vPv");

const $8b6571c5cd7e604c$export$9a0a69714186a2dc = (0, $j25oo.default);
const $8b6571c5cd7e604c$export$bf3941b9bff5380a = (contentId, skipQuery)=>{
    const $ = (0, $frIzR.c)(20);
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== skipQuery || $[3] !== t0) {
        t1 = {
            variables: t0,
            skip: skipQuery
        };
        $[2] = skipQuery;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const readTimeQueryOptions = t1;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($8b6571c5cd7e604c$export$9a0a69714186a2dc, readTimeQueryOptions);
    let t2;
    if ($[5] !== contentId || $[6] !== data || $[7] !== error || $[8] !== loading) {
        bb0: {
            const adfFromData = (0, $72md5.getAdf)(data ?? undefined);
            if (!adfFromData || loading || error || !contentId) {
                let t3;
                if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = {
                        readTime: null,
                        wordCount: null,
                        features: null,
                        featuresSkipExpand: null
                    };
                    $[10] = t3;
                } else t3 = $[10];
                t2 = t3;
                break bb0;
            }
            t2 = {
                adf: adfFromData,
                readTime: (0, $72md5.calculateEstimatedReadTime)(adfFromData),
                wordCount: (0, $72md5.getWordCount)(adfFromData),
                features: (0, $h3vPv.extractContentFeatures)(adfFromData),
                featuresSkipExpand: (0, $h3vPv.extractContentFeaturesSkipExpand)(adfFromData)
            };
        }
        $[5] = contentId;
        $[6] = data;
        $[7] = error;
        $[8] = loading;
        $[9] = t2;
    } else t2 = $[9];
    const { adf: adf, readTime: readTime, wordCount: wordCount, features: features, featuresSkipExpand: featuresSkipExpand } = t2;
    const contentNode = data?.content?.nodes?.[0];
    const contentType = contentNode?.type;
    let t3;
    if ($[11] !== adf || $[12] !== contentType || $[13] !== error || $[14] !== features || $[15] !== featuresSkipExpand || $[16] !== loading || $[17] !== readTime || $[18] !== wordCount) {
        t3 = {
            loading: loading,
            error: error,
            adf: adf,
            contentType: contentType,
            readTime: readTime,
            wordCount: wordCount,
            features: features,
            featuresSkipExpand: featuresSkipExpand
        };
        $[11] = adf;
        $[12] = contentType;
        $[13] = error;
        $[14] = features;
        $[15] = featuresSkipExpand;
        $[16] = loading;
        $[17] = readTime;
        $[18] = wordCount;
        $[19] = t3;
    } else t3 = $[19];
    return t3;
};
module.exports["ReadTimeQuery"] = $8b6571c5cd7e604c$export$9a0a69714186a2dc;
module.exports["useReadTime"] = $8b6571c5cd7e604c$export$bf3941b9bff5380a;

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<73e6f733cbfadb69e70ae427aebee2a1>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("72md5", function(module, exports) {

var $h3vPv = parcelRequire("h3vPv");

const $7a7682e083b4bc67$var$wpm = 265; // words per minute, inspired by Medium.com
const $7a7682e083b4bc67$var$minute = 60;
const $7a7682e083b4bc67$export$dbd433271872c208 = (imageCount)=>{
    let readTime = 0;
    for(let i = 0; i < imageCount; i++)readTime += Math.max(12 - i, 3);
    return readTime;
};
const $7a7682e083b4bc67$export$a44553c2ca45b9b3 = (adf)=>{
    if (adf) {
        const extractedFeatures = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
        const features = extractedFeatures;
        const readTime = (features.wordCount / $7a7682e083b4bc67$var$wpm * 60 + $7a7682e083b4bc67$export$dbd433271872c208(features.imageCount)) / $7a7682e083b4bc67$var$minute;
        if (readTime > 0.5) return Math.round(readTime);
    }
    return 0;
};
const $7a7682e083b4bc67$export$da369a1128d64cc6 = (response)=>{
    const representation = response?.content?.nodes?.[0]?.body?.dynamic?.representation;
    if (representation === 'atlas_doc_format') {
        const adfString = response?.content?.nodes?.[0]?.body?.dynamic?.value;
        if (adfString) try {
            return JSON.parse(adfString);
        } catch  {
            return null;
        }
    }
    return null;
};
const $7a7682e083b4bc67$export$d7ca718a8dbe1f35 = ({ contentType: contentType, contentId: contentId, adf: adf, isInEditor: isInEditor })=>({
        type: 'sendOperationalEvent',
        data: {
            source: 'confluence-frontend',
            action: 'extracted',
            actionSubject: 'contentFeature',
            objectType: contentType,
            objectId: contentId,
            attributes: {
                ...(0, $h3vPv.extractContentFeatures)(adf),
                isInEditor: isInEditor
            }
        }
    });
const $7a7682e083b4bc67$export$dba3e2bcdbd49da4 = (adf)=>{
    if (!adf) return 0;
    const features = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
    return features.wordCount;
};
const $7a7682e083b4bc67$export$2ac19802f4188b34 = (bodyDynamic)=>{
    if (!bodyDynamic || bodyDynamic.representation !== 'atlas_doc_format') return false;
    const adfString = bodyDynamic.value;
    if (!adfString) return false;
    let adf;
    try {
        adf = JSON.parse(adfString);
    } catch  {
        return false;
    }
    const { wordCount: wordCount, imageCount: imageCount } = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
    return wordCount > 0 || imageCount > 0;
};
module.exports["calculateImageReadTime"] = $7a7682e083b4bc67$export$dbd433271872c208;
module.exports["calculateEstimatedReadTime"] = $7a7682e083b4bc67$export$a44553c2ca45b9b3;
module.exports["getAdf"] = $7a7682e083b4bc67$export$da369a1128d64cc6;
module.exports["getContentFeatureExtractedEventObject"] = $7a7682e083b4bc67$export$d7ca718a8dbe1f35;
module.exports["getWordCount"] = $7a7682e083b4bc67$export$dba3e2bcdbd49da4;
module.exports["docHasContent"] = $7a7682e083b4bc67$export$2ac19802f4188b34;

});

parcelRegister("h3vPv", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");

// helper function to traverse ADF tree while skipping expand nodes
const $a8469c4e0ee76bb2$var$reduceSkipExpand = (node, reducer, initialValue)=>{
    // skip if this is an expand node
    if (node.type === 'expand' || node.type === 'nestedExpand') return initialValue;
    // process current node
    let result = reducer(initialValue, node);
    // process child nodes if they exist
    if (node.content) result = node.content.reduce((acc, child)=>$a8469c4e0ee76bb2$var$reduceSkipExpand(child, reducer, acc), result);
    return result;
};
const $a8469c4e0ee76bb2$var$wordCount = (text)=>{
    if (text) {
        const matches = text.match(/\S+/g);
        if (matches) return matches.length;
    }
    return 0;
};
const $a8469c4e0ee76bb2$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            return {
                ...currentValue,
                textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                wordCount: currentValue.wordCount + $a8469c4e0ee76bb2$var$wordCount(node.text)
            };
        case 'media':
            return {
                ...currentValue,
                imageCount: currentValue.imageCount + 1,
                mediaFiles: node.attrs?.type === 'file' && node.attrs?.id ? currentValue.mediaFiles.concat(node.attrs.id) : currentValue.mediaFiles
            };
        case 'inlineExtension':
            return {
                ...currentValue,
                inlineMacroCount: currentValue.macroCount + 1
            };
        case 'extension':
            return {
                ...currentValue,
                macroCount: currentValue.macroCount + 1
            };
        case 'table':
            return {
                ...currentValue,
                tableCount: currentValue.tableCount + 1
            };
        case 'embedCard':
            const url = node.attrs?.url;
            if (!url.includes('loom')) return currentValue;
            const videoId = url?.split('/').pop().split('?')[0];
            return {
                ...currentValue,
                looms: videoId ? currentValue.looms.concat({
                    id: videoId,
                    url: url
                }) : currentValue.looms
            };
    }
    return currentValue;
};
const $a8469c4e0ee76bb2$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return (0, $1A9t2.reduce)(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
const $a8469c4e0ee76bb2$export$8e18062037dcc9dd = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return $a8469c4e0ee76bb2$var$reduceSkipExpand(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
module.exports["extractContentFeatures"] = $a8469c4e0ee76bb2$export$a148305df2eb5487;
module.exports["extractContentFeaturesSkipExpand"] = $a8469c4e0ee76bb2$export$8e18062037dcc9dd;

});

parcelRegister("x4n5k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c07c4c04f9f99a3868a6c26b78654ed8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0636793d229b2435$var$_react = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("42omo")));

var $0636793d229b2435$var$_baseNew = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0636793d229b2435$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0636793d229b2435$var$BookOpenIcon = (props)=>/*#__PURE__*/ $0636793d229b2435$var$_react.default.createElement($0636793d229b2435$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$0636793d229b2435$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $0636793d229b2435$var$_default = module.exports.default = $0636793d229b2435$var$BookOpenIcon;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("6vKU8", function(module, exports) {

let $4bda05944737c7e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4bda05944737c7e7$var$load("hcSzd"),
    $4bda05944737c7e7$var$load("cSBzF"),
    $4bda05944737c7e7$var$load("6wr18"),
    $4bda05944737c7e7$var$load("ffEVr"),
    $4bda05944737c7e7$var$load("5tmW9"),
    $4bda05944737c7e7$var$load("bAAmE")
]).then(()=>parcelRequire('jgpqF'));

});

parcelRegister("iz4WO", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $9wGTI = parcelRequire("9wGTI");

const $a33c6d5d862efa17$export$cb03d08131b95fd = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    return {
        isSmartButtonAllowed: isPremium || (0, $9wGTI.fg)('a4c_free_and_standard_editions')
    };
};
module.exports["useSmartButtonPremiumGate"] = $a33c6d5d862efa17$export$cb03d08131b95fd;

});


//# sourceMappingURL=ReadTime.a826f17f.js.map
